import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { IconsLibrary } from "../../shared/util/FontAwesomeIconsUtil";

function Rating({ reviews, grade, ...rest }) {
    const noRating = !grade;
    const rating = !!grade ? grade <= 5 ? grade : 5 : 0;

    const stars = [];
    const breakpoint = Math.ceil(rating);
    const low = Math.floor(rating);

    for (let i = 0; i < breakpoint; i++) {
        if (i < low) {
            stars.push(<FontAwesomeIcon key={i} icon={IconsLibrary.faStar} className="text-yellow" />);
        } else if (i === low) {
            if (breakpoint > low) {
                stars.push(<FontAwesomeIcon key={i} icon={IconsLibrary.faStarHalf} className="text-yellow" />);
            } else {
                stars.push(<FontAwesomeIcon key={i} icon={IconsLibrary.faStar} className="text-gray" />);
            }
        }
    }

    return (
        <>
            {!noRating && (
                <>
                    <div className="flex flex-nowrap space-x-1 text-lg text-gray-light justify-center items-center self-center mx-auto">
                        {stars}
                        <span className="text-gray-darker font-bold ml-2">({grade})</span>
                    </div>
                </>
            )}
        </>
    );
}

export default Rating;